<mat-dialog-content class="entry-details">

  <div class="details-section">
    <div class="total line">
      Total: {{ entry.total || 0 | amount | currency }}
    </div>
    <div class="line">
      <div class="subtitle">
        Show Id:
      </div>
      <div class="value">
        {{ entry.showId }}
      </div>
    </div>
    <div class="line">
      <div class="subtitle">
        Show Name:
      </div>
      <div class="value">
        {{ entry.showName }}
      </div>
    </div>
    <div class="line">
      <div class="subtitle">
        Paid At:
      </div>
      <div class="value">
        {{ entry.timestamp | timestamp | date:'medium' }}
      </div>
    </div>
  </div>


  @for(order of entry.orders; track order.id) {
    <div class="details-section">
      <div class="line">
        <div class="subtitle">
          Type:
        </div>
        <div class="value">
          ENTRY
        </div>
      </div>
      <div class="line">
        <div class="subtitle">
          Rider Name:
        </div>
        <div class="value">
          {{ order.riderName }}
        </div>
      </div>
      <div class="line">
        <div class="subtitle">
          Class Code:
        </div>
        <div class="value">
          {{ order.className }}
        </div>
      </div>
      <div class="line">
        <div class="subtitle">
          Team Name:
        </div>
        <div class="value">
          {{ order.teamName }}
        </div>
      </div>
  
    </div>
  }

  @for(bookletOrder of entry.bookletOrders; track bookletOrder.id) {
    <div class="details-section">
      <div class="line">
        <div class="subtitle">
          Type:
        </div>
        <div class="value">
          BOOKLET
        </div>
      </div>
      <div class="line">
        <div class="subtitle">
          Rider Name:
        </div>
        <div class="value">
          {{ bookletOrder.riderName }}
        </div>
      </div>
  
    </div>
  }

</mat-dialog-content>
